import React from 'react';

import { Typography } from '@mui/material';

import { Dialog, DialogButton } from '@/components/Dialog';
import type { CancelablePopupContent } from '@/components/Dialog/type';

export type ConfirmationDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
} & CancelablePopupContent;

export const ConfirmationDialog = ({
  open,
  title,
  text,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      buttons={
        <>
          <DialogButton
            variant='outlined'
            onClick={onCancel}
          >
            {cancelText}
          </DialogButton>
          <DialogButton
            variant='contained'
            onClick={onConfirm}
          >
            {confirmText}
          </DialogButton>
        </>
      }
      open={open}
      title={title}
      onClose={onCancel}
    >
      <Typography>{text}</Typography>
    </Dialog>
  );
};
